import {
  initialDecisionListAdditionalFields,
  isTestAdditionalField,
} from '../constants/initialDecisionListAdditionalFields';
import { IDecisionListFilter } from '../interfaces/IDecisionListFilter';
import { IDecisionListFilterExtraField } from '../interfaces/IDecisionListFilterExtraField';

export function mapFilterAdditionalFields(isUserTest: boolean) {
  return (filter: IDecisionListFilter): IDecisionListFilterExtraField[] => {
    let items = initialDecisionListAdditionalFields;

    if (isUserTest && !initialDecisionListAdditionalFields.find(i => i.id === isTestAdditionalField.id)) {
      items = [...initialDecisionListAdditionalFields, isTestAdditionalField];
    }

    return items.map<IDecisionListFilterExtraField>(field => {
      switch (field.id) {
        case 'supervisionType': {
          return {
            ...field,
            isSelected: Boolean(filter.supervisionType?.value),
          };
        }
        case 'reasons': {
          return {
            ...field,
            isSelected: Boolean(filter.reasons?.length),
          };
        }
        case 'subjectTypes': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectTypes?.length),
          };
        }
        case 'subjectOrgName': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectOrgName),
          };
        }
        case 'subjectOgrn': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectOgrn),
          };
        }
        case 'subjectInn': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectInn),
          };
        }
        case 'subjectKpp': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectKpp),
          };
        }
        case 'subjectCountries': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectCountries?.length),
          };
        }
        case 'objectAddress': {
          return {
            ...field,
            isSelected: Boolean(filter.objectAddress),
          };
        }
        case 'objectTypes': {
          return {
            ...field,
            isSelected: Boolean(filter.objectTypes?.length),
          };
        }
        case 'objectKinds': {
          return {
            ...field,
            isSelected: Boolean(filter.objectKinds?.length),
          };
        }
        case 'objectSubKinds': {
          return {
            ...field,
            isSelected: Boolean(filter.objectSubKinds?.length),
          };
        }
        case 'objectRiskCategory': {
          return {
            ...field,
            isSelected: Boolean(filter.objectRiskCategory),
          };
        }
        case 'objectDangerClass': {
          return {
            ...field,
            isSelected: Boolean(filter.objectDangerClass),
          };
        }
        case 'prosecutorOrganizations': {
          return {
            ...field,
            isSelected: Boolean(filter.prosecutorOrganizations?.length),
          };
        }
        case 'signed': {
          return {
            ...field,
            isSelected: Boolean(filter.signed),
          };
        }
        case 'statuses': {
          return {
            ...field,
            isSelected: Boolean(filter.statuses?.length),
          };
        }
        case 'pubStatuses': {
          return {
            ...field,
            isSelected: Boolean(filter.pubStatuses?.length),
          };
        }
        case 'number': {
          return {
            ...field,
            isSelected: Boolean(filter.number),
          };
        }
        case 'deletedInclude': {
          return {
            ...field,
            isSelected: Boolean(filter.deletedInclude),
          };
        }
        case 'deletedOnly': {
          return {
            ...field,
            isSelected: Boolean(filter.deletedOnly),
          };
        }
        case 'isTest': {
          return {
            ...field,
            isSelected: Boolean(filter.isTest),
          };
        }
        default:
          return field;
      }
    });
  };
}
